import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { FaRegCalendarAlt } from "react-icons/fa";
import { formatThaiDate, stringHtmlTags } from "../utils/globalFunctions";

function TabContent({ items = [], currentTab = "news" }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  if (!items.length) {
    return (
      <div className="h-[400px] w-full flex justify-center items-center ">
        <h1>ไม่มีข้อมูล</h1>
      </div>
    );
  }

  const firstItem = items[0];
  const remainingItems = items.slice(1);

  return (
    <div>
      <div className="flex items-center justify-end py-4">
        <Link
          to={`/news?category=${currentTab}`}
          className="button-red-main text-md"
        >
          {t("viewAll")}
        </Link>
      </div>
      <div
        className="news-card flex flex-auto flex-wrap md:mb-4"
        style={{ width: "100%" }}
      >
        <div className="w-full md:w-[65%] p-2">
          <img
            className="w-full h-full aspect-[16/9] object-cover rounded-xl cursor-pointer"
            src={firstItem?.image}
            alt=""
            onClick={() => {navigate(`/news/${firstItem._id}`)}}
          />
        </div>
        <div className="w-full md:w-[35%] p-2">
          <div className="bg-white rounded-xl p-4 w-full h-full cursor-pointer"
            onClick={() => {navigate(`/news/${firstItem._id}`)}}
            >
            <div className="news-card__time text-sm">
              <FaRegCalendarAlt />
              <span>{formatThaiDate(firstItem?.datetime)}</span>
            </div>
            <div className="news-card__title text-xl">{firstItem?.title}</div>
            <span
              className="block w-full h-[4px] bg-[var(--base-color)] mb-4"
              role="presentation"
            />
            <div className="news-card__detail line-clamp-[10] text-md text-[#333333]">
              {stringHtmlTags(firstItem?.description ?? "")}
            </div>
            <div className="flex items-center justify-end pt-4">
              <Link className="button-red-main text-md" to={firstItem?.url}>
                {t("viewMore")}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-auto flex-wrap p-2">
        {remainingItems.map((item, index) => (
          <Link key={index} to={item.url} className="news-card">
            <div className="news-card__image">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="news-card__time text-sm">
              <FaRegCalendarAlt />
              <span>{formatThaiDate(item.datetime)}</span>
            </div>
            <div className="news-card__title text-white text-lg">
              {item.title}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default TabContent;
